<template>

  <component :is="el" :label="label" :required="required" :error="error">
    <i v-if="noForm">{{label}}&nbsp;</i>

    <el-select
      v-model="formData"
      :placeholder="placeholder"
      value-key="value"
      :size="size"
      :disabled="disabled"
      @change="updated">

      <el-option
        v-for="(item, index) in (!limited ? items : limited)"
        :key="item.value"
        :label="item.label"
        :value="item.value">
    </el-option>

    </el-select>

  </component>

</template>

<script>

// XOL-67: the select's value is an org id. A caller may hold the organisation as an object ({ id, name } from the API, or this select's own
// { value, label, id, name }) or an empty {} for none. Element's el-select with `value-key` compared an object's missing key with each option's
// (also missing) key, undefined === undefined, so {} showed the FIRST option as chosen while nothing was: the Tower Supplier the RTA option and
// Finalize showed but never saved. An object is read as its id, and {} / '' as no value.
function orgId (v) {
  if (v && typeof v === 'object') {
    if (v.value !== undefined && v.value !== null) return v.value
    if (v.id !== undefined && v.id !== null) return v.id
    return null
  }

  return v === '' || v === undefined ? null : v
}

export default {
  name: 'select-org',



  props: {

    label: {
      type: String,
      default: 'Organisation'
    },

    value: {
//      type: String,
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    type: {
      type: String,
      default: 'Telco'
    },

    required: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: 'default'
    },

    placeholder: {
      type: String,
      default: null
    },

    helpText: {
      type: String,
      default: null
    },

    fullObject: {
      type: Boolean,
      default: false
    },

    limit: {
      type: Array,
      default: null
    },

    isAdmin: {
      type: Boolean,
      default: false
    },

    noForm: {
      type: Boolean,
      default: false
    },

    // XOL-487: additive — el-form-item's plain `error` String prop, a display
    // watcher independent of :model/:rules/validate(). default: null (not
    // '') so Vue omits the attribute entirely when `el` renders as a bare
    // div in no-form mode. Inert for every other call site.
    error: {
      type: String,
      default: null
    }

  },



  methods: {

    selectCategory (list, cat = null) {
      let org = {}

      for (let i = 0; i < list.length; i++) {

        if (list[i].label.toLowerCase() === cat.toLowerCase()) {
          org = list[i].options
        }

      }

      return org
    },


    doLimits (lim, items) {

      this.limited = null

      if (this.isArray(lim) && this.isArray(items)) {
        this.limited = []

        for (let l = 0; l < lim.length; l++) {
          for (let i = 0; i < items.length; i++) {

            if (items[i].data.id === lim[l]) {
              this.limited.push(items[i])
            }

          } // for limit

        } // for items

        return this.limited
      } // if limit

      return items
    },


    updated (id) {
      let org = null

      for (let i = 0; i < this.items.length; i++) {

        if (this.items[i].value === id) {
          org = this.items[i]
          org.id = org.value
          org.name = org.label
          break
        }
      }

      this.$emit('input', this.fullObject ? org : id)
      this.$emit('change', this.fullObject ? org : id)
    }

  },


  watch: {

    // XOL-67: follow the parent's value (it was read once, in data(), so a row loaded after mount never showed).
    value: function (v) {
      this.formData = orgId(v)
    },

    limit: function (lim) {
      this.doLimits(lim, this.items)
    },

    type: function (type) {
      this.items = []
      this.items = this.selectCategory(this.getConfig().orgGroups, type)
    }

  },

  data () {
    return {
      formData: orgId(this.value),
      items: this.selectCategory(this.getConfig().orgGroups, this.type),
      limited: null,
      el: this.noForm ? 'div' : 'el-form-item'
    }
  },

  created () {
    this.doLimits(this.limit, this.items)
//    console.log('select-org: type', this.type, 'disabled', this.disabled, 'el', this.el, 'items', this.items, 'limited', this.limited)
  }

}
</script>
